<div class="flex flex-col items-stretch justify-start gap-2">
	@if (isEnableRoleButton(role.GROUP_ADMIN)) {
		<button
			class="aa-btn"
			data-size="small"
			[attr.data-variant]="isActive(role.GROUP_ADMIN) ? 'primary' : 'tertiary'"
			(click)="switchRoleThenClose(role.GROUP_ADMIN)"
		>
			Group Admin
		</button>
	}
	@if (isEnableRoleButton(headAdminRole)) {
		<button
			class="aa-btn"
			data-size="small"
			[attr.data-variant]="isActive(headAdminRole) ? 'primary' : 'tertiary'"
			(click)="switchRoleThenClose(headAdminRole)"
		>
			Head Admin
		</button>
	}
	@if (isEnableRoleButton(role.ADMIN)) {
		<button
			class="aa-btn"
			data-size="small"
			[attr.data-variant]="isActive(role.ADMIN) ? 'primary' : 'tertiary'"
			(click)="switchRoleThenClose(role.ADMIN)"
		>
			Admin
		</button>
	}
	@if (isEnableRoleButton(role.OFFICE_ADMIN)) {
		<button
			class="aa-btn"
			data-size="small"
			[attr.data-variant]="isActive(role.OFFICE_ADMIN) ? 'primary' : 'tertiary'"
			(click)="switchRoleThenClose(role.OFFICE_ADMIN)"
		>
			Office Admin
		</button>
	}
	@if (isEnableRoleButton(role.INSTRUCTOR)) {
		<button
			class="aa-btn"
			data-size="small"
			[attr.data-variant]="isActive(role.INSTRUCTOR) ? 'primary' : 'tertiary'"
			(click)="switchRoleThenClose(role.INSTRUCTOR)"
		>
			Instructor
		</button>
	}
	@if (isEnableRoleButton(role.PILOT)) {
		<button
			class="aa-btn"
			data-size="small"
			[attr.data-variant]="isActive(role.PILOT) ? 'primary' : 'tertiary'"
			(click)="switchRoleThenClose(role.PILOT)"
		>
			Pilot
		</button>
	}
	@if (isEnableRoleButton(role.CABIN_CREW)) {
		<button
			class="aa-btn"
			data-size="small"
			[attr.data-variant]="isActive(role.CABIN_CREW) ? 'primary' : 'tertiary'"
			(click)="switchRoleThenClose(role.CABIN_CREW)"
		>
			Cabin Crew
		</button>
	}
	@if (isEnableRoleButton(role.CABIN_CREW_INSTRUCTOR)) {
		<button
			class="aa-btn"
			data-size="small"
			[attr.data-variant]="isActive(role.CABIN_CREW_INSTRUCTOR) ? 'primary' : 'tertiary'"
			(click)="switchRoleThenClose(role.CABIN_CREW_INSTRUCTOR)"
		>
			Cabin Crew Instructor
		</button>
	}
</div>
